const ViewISPDetail = () => {
    return (
        <div>View ISP Detail</div>
    )
}

export default ViewISPDetail